<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>AG Grid</h1>
					<p waBody="m" waText>Feature-rich data grid &#40;AG Grid 35.0.0&#41; &mdash; server-driven configuration, column definitions, row models, filtering, sorting, pagination, and real-time updates, all as type-safe Java with Angular integration. Supports client-side and server-side row models with CRTP fluent builders.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">AG Grid 35.0.0</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:aggrid</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.aggrid</p>
					<p waBody="s" waText>Built on: AG Grid 35.0.0</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_512" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_513" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-details summary="NPM Dependencies (auto-included)">
					<markdown [data]="mdContent_514" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;3&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgGrid</h4>
								<p waBody="s" waColorText="quiet" waText>Main grid component with CRTP fluent API, WebSocket data binding, and Angular template generation</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">4 props</wa-tag>
									<wa-tag pill variant="neutral">16 methods</wa-tag>
									<wa-tag pill variant="warning">4 events</wa-tag>
									<wa-tag pill variant="success">2 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/aggrid/ag-grid']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgGridColumnDef</h4>
								<p waBody="s" waColorText="quiet" waText>Column definition controlling field binding, display, sorting, filtering, editing, grouping, and rendering</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">49 props</wa-tag>
									<wa-tag pill variant="neutral">30 methods</wa-tag>
									<wa-tag pill variant="success">4 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/aggrid/ag-grid-column-def']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>AgGridOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Grid options using modular &#64;JsonUnwrapped composition &mdash; groups options into specialized sub-objects that flatten to a single JSON output</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">62 props</wa-tag>
									<wa-tag pill variant="neutral">21 methods</wa-tag>
									<wa-tag pill variant="success">6 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/aggrid/ag-grid-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (12)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>Server-driven configuration &mdash; define grids entirely in Java with CRTP fluent API</p>
						<p waBody="s" waColorText="quiet" waText>Type-safe column definitions &mdash; AgGridColumnDef with field, header, width, cellRenderer, cellDataType</p>
						<p waBody="s" waColorText="quiet" waText>Row selection &mdash; single and multiple selection modes</p>
						<p waBody="s" waColorText="quiet" waText>Pagination &mdash; built-in pagination with configurable page sizes</p>
						<p waBody="s" waColorText="quiet" waText>Filtering and sorting &mdash; client-side and server-side with multi-column support</p>
						<p waBody="s" waColorText="quiet" waText>Cell renderers &mdash; custom cell rendering with Java-based ICellRenderer implementations</p>
						<p waBody="s" waColorText="quiet" waText>Event handling &mdash; row selection, cell clicks, custom events with type-safe handlers</p>
						<p waBody="s" waColorText="quiet" waText>Real-time updates &mdash; WebSocket integration for live data streaming</p>
						<p waBody="s" waColorText="quiet" waText>Module registry &mdash; AllCommunityModule auto-registered via PageConfigurator</p>
						<p waBody="s" waColorText="quiet" waText>Angular 21 integration &mdash; auto-generated components with change detection</p>
						<p waBody="s" waColorText="quiet" waText>Reactive data binding &mdash; built on Vert.x 5 for non-blocking operations</p>
						<p waBody="s" waColorText="quiet" waText>JSON serialization &mdash; automatic Jackson serialization for Angular binding</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (2)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Define a Data Grid</h4>
							<p waBody="s" waColorText="quiet" waText>Create a grid with pagination, row selection, and typed column definitions.</p>
							<markdown [data]="mdContent_515" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Modular Options Composition</h4>
							<p waBody="s" waColorText="quiet" waText>Configure grid features using the &#64;JsonUnwrapped modular pattern.</p>
							<markdown [data]="mdContent_516" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_517" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (1)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>AgGridPageConfigurator auto-registers AllCommunityModule and ag-grid CSS/JS</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://www.ag-grid.com/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://www.ag-grid.com/documentation/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/AgGrid</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>